import React, { useEffect, useState } from "react";
import type { CalculatorField } from "../../data/calculator";
import { clamp } from "../../utils/currency";
import { trackOnce } from "../../utils/tracking";
type CalculatorInputProps = {
  field: CalculatorField;
  value: number;
  onChange: (value: number) => void;
};
export function CalculatorInput({
  field,
  value,
  onChange
}: CalculatorInputProps) {
  const [draft, setDraft] = useState(String(value));
  const id = `calc-${field.key}`;
  const fill = (value - field.min) / (field.max - field.min) * 100;
  useEffect(() => setDraft(String(value)), [value]);
  const commit = () => {
    const parsed = Number(draft.replace(/[^\d.]/g, ""));
    const next = Number.isFinite(parsed) && draft.trim() !== "" ? clamp(parsed, field.min, field.max) : field.min;
    onChange(next);
    setDraft(String(next));
  };
  return <div className="border-b border-line px-5 py-5 last:border-b-0 md:px-8 md:py-7" data-id="element-96" data-mp="345qfo38p5dru">
      <div className="flex items-center justify-between gap-6" data-id="element-97" data-mp="2zaks6zznbr1n">
        <label htmlFor={id} className="text-[15px] font-medium leading-snug text-cream md:text-[16px]" data-id="element-98" data-mp="3sel7wgzdpqdw">
          {field.label}
        </label>
        {/* Mobile: read-only value, sliders only */}
        <span className="shrink-0 font-ui text-[16px] font-bold tabular-nums text-gold md:hidden" aria-hidden="true" data-id="element-99" data-mp="58kes31q1q42">
          {field.prefix}
          {value.toLocaleString("en-US")}
          {field.suffix}
        </span>
        <div className="hidden h-12 w-32 shrink-0 items-center rounded-[3px] border border-steel bg-ink px-3 transition-colors duration-150 ease-out focus-within:border-gold md:flex" data-id="element-100" data-mp="f6i46tvbhsy9">
          {field.prefix && <span className="text-muted" data-id="element-101" data-mp="oxcp9uwtumi4">{field.prefix}</span>}
          <input id={id} type="text" inputMode="numeric" value={draft} onChange={e => {
          setDraft(e.target.value);
          const n = Number(e.target.value.replace(/[^\d.]/g, ""));
          if (e.target.value.trim() !== "" && Number.isFinite(n) && n >= field.min && n <= field.max) {
            onChange(n);
          }
        }} onBlur={commit} onKeyDown={e => e.key === "Enter" && commit()} className="w-full min-w-0 bg-transparent text-right font-ui text-[16px] font-bold tabular-nums text-cream focus:outline-none" data-id="element-102" data-mp="syo91jt0sdie" />
          {field.suffix && <span className="ml-1 text-muted" data-id="element-103" data-mp="3hpyllnb3ikss">{field.suffix}</span>}
        </div>
      </div>
      <input type="range" aria-label={field.label} aria-valuetext={`${field.prefix ?? ""}${value}${field.suffix ?? ""}`} min={field.min} max={field.max} step={field.step} value={value} onChange={e => {
      trackOnce("CalculatorUsed", {}, {
        custom: true
      });
      onChange(Number(e.target.value));
    }} className="range-gold mt-2 h-1 w-full cursor-pointer appearance-none rounded-full accent-[#FFB700] md:mt-5" style={{
      background: `linear-gradient(to right, #FFB700 ${fill}%, #4C4C4C ${fill}%)`,
      ["--fill" as string]: `${fill}%`
    }} data-id="element-104" data-mp="3don3s3ygr3v5" />
      <div className="mt-1 flex justify-between text-[12px] tabular-nums text-muted md:mt-2" data-id="element-105" data-mp="crkqnu06byi1">
        <span data-id="element-106" data-mp="3u8kfvvqwxghs">
          {field.prefix}
          {field.min.toLocaleString("en-US")}
          {field.suffix}
        </span>
        <span data-id="element-107" data-mp="306otfkr2mlq">
          {field.prefix}
          {field.max.toLocaleString("en-US")}
          {field.suffix}
        </span>
      </div>
    </div>;
}